import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';

import { commonStore } from 'stores/common';
import { useTypedLocation } from 'hooks';

import { Links } from 'links';

export const DataPage = () => {
  const user = commonStore((state) => state.user);
  const isSessionExpired = commonStore((state) => state.isSessionExpired);

  const navigate = useNavigate();

  const { search, state } = useTypedLocation();

  useEffect(() => {
    if (!isSessionExpired && user) {
      navigate({ search, pathname: state?.redirectFrom || Links.Snaps }, { replace: true });
    }
  }, [isSessionExpired, user]);

  return (
    <Spin size='large'>
      <div className='h-[100vh] w-[100vw]' />
    </Spin>
  );
};
